var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5F3841"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 1L37.1362 3.00402C37.204 4.00171 37.9983 4.79599 38.996 4.8638L41 5L38.996 5.1362C37.9983 5.20401 37.204 5.99829 37.1362 6.99598L37 9L36.8638 6.99598C36.796 5.99829 36.0017 5.20401 35.004 5.1362L33 5L35.004 4.8638C36.0017 4.79599 36.796 4.00171 36.8638 3.00402L37 1Z",
    fill: "#D37B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17L4.66802 19.4722C4.73583 20.4699 5.53011 21.2642 6.5278 21.332L9 21.5L6.5278 21.668C5.53011 21.7358 4.73583 22.5301 4.66802 23.5278L4.5 26L4.33198 23.5278C4.26417 22.5301 3.46989 21.7358 2.4722 21.668L0 21.5L2.4722 21.332C3.46989 21.2642 4.26417 20.4699 4.33198 19.4722L4.5 17Z",
    fill: "#D37B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 30L36.2635 33.8767C36.3313 34.8744 37.1256 35.6687 38.1233 35.7365L42 36L38.1233 36.2635C37.1256 36.3313 36.3313 37.1256 36.2635 38.1233L36 42L35.7365 38.1233C35.6687 37.1256 34.8744 36.3313 33.8767 36.2635L30 36L33.8767 35.7365C34.8744 35.6687 35.6687 34.8744 35.7365 33.8767L36 30Z",
    fill: "#EEBBC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8562 12.4844C25.6781 12.1844 25.35 12 25 12C24.65 12 24.3219 12.1844 24.1438 12.4844L21.1438 17.4844C20.9594 17.7937 20.9531 18.1781 21.1312 18.4906C21.3094 18.8031 21.6406 18.9969 22 18.9969H28C28.3594 18.9969 28.6937 18.8031 28.8687 18.4906C29.0437 18.1781 29.0406 17.7937 28.8562 17.4844L25.8562 12.4844ZM25 21.75V26.25C25 26.9406 25.5594 27.5 26.25 27.5H30.75C31.4406 27.5 32 26.9406 32 26.25V21.75C32 21.0594 31.4406 20.5 30.75 20.5H26.25C25.5594 20.5 25 21.0594 25 21.75ZM20 28C21.0609 28 22.0783 27.5786 22.8284 26.8284C23.5786 26.0783 24 25.0609 24 24C24 22.9391 23.5786 21.9217 22.8284 21.1716C22.0783 20.4214 21.0609 20 20 20C18.9391 20 17.9217 20.4214 17.1716 21.1716C16.4214 21.9217 16 22.9391 16 24C16 25.0609 16.4214 26.0783 17.1716 26.8284C17.9217 27.5786 18.9391 28 20 28Z",
    fill: "#F7CFD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon);
export default __webpack_public_path__ + "static/media/Integrations Icon.19d81168fdf2a3752dda748d17c2659b.svg";
export { ForwardRef as ReactComponent };